import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table";
import { Badge } from "./ui/badge";
import { Alert, AlertDescription } from "./ui/alert";
import { Progress } from "./ui/progress";
import { 
  Calculator, 
  Play,
  RotateCcw,
  DollarSign,
  TrendingUp,
  BarChart3,
  Settings,
  AlertCircle,
  CheckCircle,
  Activity
} from "lucide-react";
import axios from "axios";

const API = require('../services/apiBase').default || require('../services/apiBase');

const ContractAllocationEngine = ({ calculationId, contracts, onAllocationsUpdate, onResultsUpdate }) => {
  const [loading, setLoading] = useState(false);
  const [allocating, setAllocating] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  
  // Allocation configuration
  const [allocationMethods, setAllocationMethods] = useState({
    fringe: "direct_labor",
    overhead: "direct_labor", 
    ga: "total_costs",
    ird: "revenue_percentage",
    bp: "revenue_percentage",
    com: "asset_allocation"
  });
  
  // Allocation results
  const [allocationResults, setAllocationResults] = useState(null);
  const [rateData, setRateData] = useState(null);
  const [lastAllocationDate, setLastAllocationDate] = useState(null);

  useEffect(() => {
    if (calculationId) {
      loadRateData();
      loadAllocationResults();
    }
  }, [calculationId]);

  const loadRateData = async () => {
    try {
      const response = await axios.get(`${API}/calculation/${calculationId}`);
      setRateData(response.data.rate_calculations);
    } catch (e) {
      console.error("Error loading rate data:", e);
    }
  };

  const loadAllocationResults = async () => {
    try {
      const response = await axios.get(`${API}/contract-allocations/${calculationId}`);
      if (response.data.success) {
        setAllocationResults(response.data.allocation_results);
        setLastAllocationDate(response.data.last_allocation_date);
        onResultsUpdate(response.data.allocation_results);
      }
    } catch (e) {
      if (e.response?.status !== 404) {
        console.error("Error loading allocation results:", e);
      }
    }
  };

  const handleRunAllocation = async () => {
    setAllocating(true);
    setError(null);
    setSuccess(null);

    try {
      const allocationData = {
        is_final: false,
        allocation_methods: allocationMethods
      };

      const response = await axios.post(`${API}/contract-allocations/${calculationId}`, allocationData);
      
      if (response.data.success) {
        setSuccess(`Contract allocations completed successfully!`);
        setAllocationResults(response.data.allocation_results);
        setLastAllocationDate(new Date().toISOString());
        onAllocationsUpdate(response.data.allocations);
        onResultsUpdate(response.data.allocation_results);
        setTimeout(() => setSuccess(null), 5000);
      }
      
    } catch (e) {
      setError(e.response?.data?.detail || "Error running contract allocations");
    } finally {
      setAllocating(false);
    }
  };

  // ... rest of component remains identical
};

export default ContractAllocationEngine;